import { FontPoppins } from '@/constants/font';
import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { Platform, Pressable, TextInput, TextInputProps, View } from 'react-native';

type SearchInputProps = TextInputProps & {
  onSearch?: (query: string) => void;
  value: string;
};

export function SearchInput({ style, onSearch, value, onChangeText, ...rest }: SearchInputProps) {
  const handleSearchSubmit = () => {
    if (onSearch && value) {
      onSearch(value.trim());
    }
  };

  return (
    <View className="h-10 flex-row items-center gap-2 rounded-full bg-neutral-100 px-3.5">
      <Ionicons className="text-neutral-400" name="search" size={16} />
      <TextInput
        style={[
          {
            flex: 1,
            fontSize: 13,
            fontFamily: FontPoppins.REGULAR,
            paddingVertical: 0,
          },
          Platform.OS === 'web' && ({ outline: 'none' } as never),
          style,
        ]}
        placeholderTextColor="#A3A3A3"
        className="text-foreground"
        value={value}
        onChangeText={onChangeText}
        onSubmitEditing={handleSearchSubmit}
        returnKeyType="search"
        {...rest}
      />
      {value.length > 0 && (
        <Pressable
          onPress={() => onChangeText?.('')}
          accessibilityRole="button"
          accessibilityLabel="Limpar busca"
          hitSlop={8}
        >
          <Ionicons className="text-neutral-400" name="close-circle" size={16} />
        </Pressable>
      )}
    </View>
  );
}
